// Интеграции (перенос из Office, круг 2: экраны сотрудников к перенесённым в integration_ext кнопкам Tilda/Planoplan/db-conn).
// Ключ pages = menu_action пункта меню (office_api/office_port/areas/integration_more/endpoints.py MENU).
export const pages = {
  officeImPlanoplan: "/office/integration-more/planoplan",
  officeImTilda: "/office/integration-more/tilda-projects",
  officeImDbConn: "/office/integration-more/db-conn",
};

export const routes = [
  { path: "/office/integration-more/planoplan", name: "officeImPlanoplan", meta: { layout: "main", title: "Planoplan: рендеры планировок" },
    component: () => import("@/views/office/integration_more/Planoplan.vue") },
  { path: "/office/integration-more/tilda-projects", name: "officeImTilda", meta: { layout: "main", title: "Проекты на Тильда" },
    component: () => import("@/views/office/integration_more/TildaProjects.vue") },
  { path: "/office/integration-more/db-conn", name: "officeImDbConn", meta: { layout: "main", title: "Подключение к базе данных" },
    component: () => import("@/views/office/integration_more/DbConn.vue") },
];
